'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';

/**
 * Keep the post-paint flip: Web3Provider gates AppKit initialization on this value, and
 * initializing AppKit before EIP-6963 wallets announce can omit MetaMask and Ledger.
 *
 * For a hydration gate with no paint-timing requirement, use {@link useIsHydrated} instead: a
 * client-navigation mount reads `true` on its first render there, and never flashes the gate.
 */
export function useIsMounted() {
  const $ = _c(2);
  const isMountedRef = useRef(false);
  const [isMounted, setIsMounted] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      isMountedRef.current = true;
      setIsMounted(true);
      return () => {
        isMountedRef.current = false;
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isMounted;
}